import React from 'react';
export var ViewerContainerSizeContext = React.createContext(undefined);
ViewerContainerSizeContext.displayName = 'ViewerContainerSizeContext';
//# sourceMappingURL=ViewerContainerSizeContext.js.map